import { AbstractDownloadableService } from "./abstract-downloadable.service";
import { ReservationActivity } from '../models';

/**
 * @class ActivityLogPmsApiService
 * @abstract
 * @extends {AbstractDownloadableService<ReservationActivity>}
 */
export class ActivityLogPmsApiService extends AbstractDownloadableService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/activity-log';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @param params
     * @returns {ReservationActivity}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ReservationActivity(attributes);
    }
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<ReservationActivity>>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .post(url, params,{
                headers: this.authHeaders,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    exportCsv(params = {}, property = null) {

        const url =  this.url({propertyId: property ? property.id : 0}) + '/export-csv';

        return this.download(url, params, 'Activity Log.csv');
    }

    exportExcel(params = {}, property = null) {

        const url =  this.url({propertyId: property ? property.id : 0}) + '/export-excel';

        return this.download(url, params, 'Activity Log.xls');
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/activity-log.service.js